
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.632 16.52l.155-1.466.462-.313c1.088-.737 1.551-1.732 1.551-2.869 0-1.136-.67-2.32-1.974-3.101-.884-.522-1.944-.807-3.07-.807-3.016 0-5.044 1.968-5.044 3.908 0 .64.207 1.293.632 1.893 1.082 1.487 3.224 2.428 5.423 2.024l.428-.08 1.437.812zM8.37 14.466c-.562-.79-.858-1.685-.858-2.593 0-2.817 2.801-5.108 6.244-5.108 1.329 0 2.603.337 3.684.975 1.604.96 2.56 2.505 2.56 4.133 0 1.523-.65 2.895-2.078 3.862l-.192 1.815a.568.568 0 01-.884.47l-1.862-1.05c-2.643.486-5.255-.63-6.614-2.504z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.025 7.899c0-4.212 4.303-7.412 9.19-7.412 4.252 0 7.918 1.928 8.79 5.593a.6.6 0 01-1.167.278c-.69-2.899-3.655-4.67-7.623-4.67-4.503 0-7.99 2.91-7.99 6.21 0 1.532.772 3.013 2.137 4.183a.6.6 0 01.21.456v2.68l2.206-1.47a.6.6 0 01.51-.075c.084.026.159.048.233.069.154.044.304.087.515.165a.6.6 0 01-.415 1.126 4.312 4.312 0 00-.38-.123L6.21 14.9l-2.023 1.35c-.767.51-1.816-.03-1.816-.972v-2.471C.924 11.484.025 9.765.025 7.899z"}})])
          )
        }
      }
    